import authRules from '../authRules.js';

const deleteRequest = (user) => {
  const { deleteRequest } = user.securityLevels;
  if (deleteRequest >= authRules.deleteRequest.deleteRequest) {
    return true;
  } else {
    return false;
  }
}

export default deleteRequest;
